import React from "react";
import { FormSectionElements, FormSections } from "src/entities/formTemplateDataType";
import { getRootComponent } from "../../utilities/ElementUtils";
import FormValidationUtils from "../../utilities/FormValidationUtils";

type Props = {
    isEng: boolean;
    field: FormSectionElements;
    callback;
    callbackValidate: (errors: any) => void
}

const EditSubsectionButtonComponent = ({isEng, field, callback, callbackValidate}: Props) => {

    const editAction = () => {
        const subsec = field.parent
        const section = subsec.parent as FormSections;

       //event script added 
       if (field.EventScript) {

          try {
            const customJSFunc = eval(`(${field.EventScript})`);
            customJSFunc(field);
            } catch (ex) {
            console.log(ex);
            }
        }

        let programContainer = getRootComponent(field);
        let activeIndex = null;
        // Assumption: There is a single editable subsection.
        section.ListOfFormSubSections.forEach((sub, index) => {
            if (sub.ENUTitle == subsec.ENUTitle && !sub.ReadOnlyElements) activeIndex = index;
        });
        if (activeIndex || activeIndex == 0) {
            const invalidControlList = FormValidationUtils.invalidControls(section, subsec.ENUTitle);
            if (invalidControlList.length > 0) {
                callbackValidate(invalidControlList);
                // this.setState({ validationErrMsg: invalidControlList });
                // window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            else {
                // Make the previously editable subsection read-only.
                section.ListOfFormSubSections[activeIndex].ReadOnlyElements = true;
                // Turn the subsection that user clicked to editable.
                subsec.ReadOnlyElements = false;
                callback(programContainer);
            }
        } else {
            subsec.ReadOnlyElements = false;
            callback(programContainer);
        }
    }

    return(
        <button className="ontario-button ontario-button--secondary" onClick={editAction}>
            {isEng ? field.ENUTitle : field.FRATitle}
        </button>
    );
}

export default EditSubsectionButtonComponent;